<template>
  <v-col class="pa-6">
    <div v-if="!viewingDoc">
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field class="input" label="Search..." prepend-inner-icon="mdi-magnify" rounded></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select style="max-width: 240px" class="input" label="Type" rounded :items="docTypes"></v-select>
          </v-row>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-data-table style="width: 100%" :headers="headers" :items="desserts" :items-per-page="5"
          class="elevation-1 ml-4 mr-8">
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon color="#4390c0" @click="viewingDoc = true">mdi-eye</v-icon>
            </td>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="viewingDoc">
      <ViewDoc @close="viewingDoc = false" />
    </div>
  </v-col>
</template>

<script>
import ViewDoc from "@/components/ViewDoc.vue";

export default {
  data() {
    return {
      headers: [
        { text: "Date", value: "date" },
        {
          text: "Time",
          value: "time",
        },
        { text: "Name", value: "name" },
        { text: "Certificate", value: "certificate" },
        { text: "Action", value: "action" },
      ],
      desserts: [
        {
          date: "21-10-24",
          time: "10:00am",
          name: "Calvyn",
          certificate: "Therapy",
          action: "",
        },
      ],
      viewingDoc: false,
      docTypes: ['General'],
    };
  },
  components: {
    ViewDoc,
  },
};
</script>

<style scoped></style>